import { CoreFormFieldNumber } from '../fields/CoreFormFieldNumber';
import { FormFieldContainer } from '../layout/FormFieldContainer';
import type { ContextFormFieldBaseProps } from './ContextFormFieldBaseProps';
import type { FormFieldControllerRulesProps } from './FormFieldController';
import { FormFieldController } from './FormFieldController';

export const ContextFormFieldNumber = ({
  fieldPath,
  rules,
  disabled,
  label,
  inline,
  placeholder,
  helperText,
  colSpan,
}: ContextFormFieldBaseProps) => {
  return (
    <FormFieldContainer colSpan={colSpan}>
      <FormFieldController
        name={fieldPath}
        rules={rules as FormFieldControllerRulesProps}
      >
        {({ field, fieldState }) => (
          <CoreFormFieldNumber
            label={rules?.required ? `${label} *` : label}
            error={fieldState.error?.message?.toString()}
            inputProps={{
              id: fieldPath,
              ...field,
              onChange: field.onChange,
              disabled,
              placeholder,
              'data-testid': fieldPath,
            }}
            inline={inline}
            helperText={helperText}
          />
        )}
      </FormFieldController>
    </FormFieldContainer>
  );
};
